import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Sorting } from '../../user-management/_model/sorting.model';
import { Filter } from '../../user-management/_model/filter.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class StaffService {
    token = localStorage.getItem('token');

    constructor(private http: HttpClient) { }

    getStaff(rowsNumber: number, pageNo: number, sorting: Sorting, searchValue: string, filterValues: Filter, request_number: number) {
        let filterValuesForRolesApi = '';
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        let filterValuesForRoutesApi = '';
        if (filterValues.gates !== undefined) {
            filterValues.gates.map(gate => {
                filterValuesForRoutesApi = filterValuesForRoutesApi.concat('&filter[gate_id][]=' + gate)
            })
        }
        if (filterValues.routes !== undefined) {
            filterValues.routes.map(route => {
                filterValuesForRoutesApi = filterValuesForRoutesApi.concat('&filter[route_name][]=' + route)
            })
        }
        if (filterValues.roles !== undefined) {
            filterValues.roles.map(role => {
                filterValuesForRolesApi = filterValuesForRolesApi.concat('&filter[role][]=' + role)
            })
        }
        if (filterValues.grades !== undefined) {
            filterValues.grades.map((filterValue: string) => {
                filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue)
            })
        }
        if (filterValues.classes !== undefined) {
            filterValues.classes.map((filterValue: string) => {
                filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue)
            })
        }
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?
        role_type=staff
        &is_paginated=1
        &per_page=${rowsNumber}
        &page=${pageNo}
        ${sorting.name !== null ? '&sort[name]=' + sorting.name : ''}
        ${filterValues.registration !== -1 && filterValues.registration !== undefined ? '&filter[status][]=' + filterValues.registration : ''}
        ${filterValues.activation !== -1 && filterValues.activation !== undefined ? '&filter[activate][]=' + filterValues.activation : ''}
        ${filterValuesForGradesApi}
        ${filterValuesForClassesApi}
        ${filterValuesForRolesApi}
        ${filterValuesForRoutesApi}
        ${searchValue === undefined || searchValue === '' ? '' : '&search=' + encodeURIComponent(searchValue)} 
        &request_number=${request_number}`);
    }

    addStaff(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users`, body)
    }

    updateStaff(staffID, body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/${staffID}`, body)
    }

    getStaffById(id) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/${id}`)
    }

    assignGradesToUser(userID, body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/${userID}/grades`, body)
    }

    // Teacher class links in the current school only (BLU-65): replaces this school's classes, [] clears them,
    // other schools' classes are kept. Every id must be a class of this school (otherwise 422).
    assignClassesToUser(userID, body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/${userID}/classes`, body);
    }

    assignGateToUser(userID, body) {
        return this.http.post(environment.url + `users/${userID}/securities`, body);
    }

    generateStaffExcel(body){
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/exports/staff`, body)
    }

    generateStaffPdf(body){
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/dashboard/exports/pdf/staff`, body)
    }


    private _staffData = new BehaviorSubject<Object>(null);
    staffData = this._staffData.asObservable();


    // focus 'links' opens the dialog with the role pane in focus (Assign class / Assign gate quick action)
    setStaffData(staff, flag, focus?: 'links') {
        this._staffData.next({ 'staff': staff, 'flag': flag, 'focus': focus });
    }

    getStaffData() {
        return this._staffData;
    }

    resetStaffPassword(body) {
        return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/users/password/reset-password-to-default`, body);
    }
}